import React from 'react'
import { Box } from '@mui/joy'
import { useFormatter } from '../../utils';

const CellSimple = ({ value, type = 'simple' }) => {
    /*
    NON RIPRISTINARE, SE SI VUOLE AVERE UNA FORMATTAZIONE DEI NUMERI CREARE CELLA AD HOC
    QUESTA È LA CELLA CHE FA VEDERE QUELLO CHE È SALVATO A DB SENZA FORMATTAZIONE
    
    const { formatNumber } = useFormatter();
    const isNumeric = value !== null && value !== '' && !isNaN(value);

    if (isNumeric) {
        value = formatNumber(value);
    }
    */

    return (
        <Box className={"list-element-cell cell-" + type}>
            {value || value === 0 ? value : ''}
        </Box>
    )
}

export default CellSimple